import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { getDocumentNumber, isEmpty, mongoId } from '../../../../@core/common/global';
import { ApiService } from '../../../../@core/service/api.service';
import { AuthGuardService } from '../../../../@core/service/auth-guard.service';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import { TreeService } from '../../../../@core/service/tree.service';
import { CompilationModel, ShipmentLineItem, TransportRun } from '../../../../@models/erp/compilation';
import { DeliveryConditionsData, SpoStatusData, TaxHintData, TransportStatusData,
  UnitData } from '../../../../@models/erp/compilationData';
import { LineItemModel } from '../../../../@models/erp/lineItem';
import { Changelog } from '../../shared/changelog/changelog.component';
import { CommonDialogComponent, NrkDialogType } from '../../shared/common-dialog/common-dialog.component';
import { DocumentPrinterComponent } from '../document-printer/document-printer.component';
import { DocumentComponent } from '../document.component';
import * as moment from 'moment';

@Component({
  selector: 'ngx-combined-shipment',
  templateUrl: './combined-shipment.component.html',
  styleUrls: ['./combined-shipment.component.scss'],
})
export class CombinedShipmentComponent implements OnInit, OnChanges {

  @Input() compilation: CompilationModel;
  @Input() items: CompilationModel[];
  @Input() latestVersionItems: CompilationModel[];
  @Input() print: boolean = false;
  @Input() disabled: boolean = true;
  @Input() parent: DocumentComponent;
  @Output() reloadItems = new EventEmitter<void>();
  @Output() setCurrentDocument = new EventEmitter<string>();
  @Output() evalDateFields = new EventEmitter<void>();
  @ViewChild('documentPrinter') documentPrinter: DocumentPrinterComponent;

  moment = moment; // forward to template

  constructor(private auth: AuthGuardService, private api: ApiService, private router: Router, private tree: TreeService, private cdRef: ChangeDetectorRef,
    public data: SharedDataService, private toastrService: NbToastrService, private dialogService: NbDialogService) {}

  ngOnInit(): void {
    // if (this.items) this.evalShipmentLineItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.compilation.shipmentLineItems) this.compilation.shipmentLineItems = [];

    // if (changes.compilation && !changes.compilation.firstChange) {
    //   // this.evalShipmentLineItems();
    // }
    // this.updateSpoStatus();
    this.tree.documentTreeLoadedEvent.subscribe(tree => {
      console.log('combined shipment tree', tree);
    })
  }

  // async evalShipmentLineItems() {
  //   const validItems = [];
  //   for (const li of this.compilation.shipmentLineItems) {
  //     const doc = this.items.find(f => f._id === mongoId(li.document));
  //     if (doc && !doc.code) {
  //       const d = await this.api.loadCompilation(mongoId(li.document));
  //       doc.code = d.code;
  //     }
  //     if (!doc) continue;
  //     li.document = await this.api.loadCompilationByCode(doc.code);
  //     const ocs = await this.api.getRelatedOcs(doc.code);
  //     li.document.lineItems && li.document.lineItems.forEach((el, idx) => {
  //       if (ocs && ocs.length) {
  //         el['relatedOcs'] = ocs.filter(f => (f.pos-1) === idx);
  //         el['relatedOcsSum'] = el['relatedOcs'].map(m => m.quantity).reduce((p, c) => p + c, 0);
  //       }
  //     })
  //     // wipe out cancelled docs
  //     if (li.document.documentStatus !== DocumentStatusData.get('cancelled').id) {
  //       validItems.push(li);
  //     }
  //   }
  //   this.compilation.shipmentLineItems = validItems;
  // }

  async addItem(item: CompilationModel /* SPO */) {
    const shipmentLineItem = new ShipmentLineItem();
    shipmentLineItem.document = await this.api.loadCompilationByCode(item.code);
    shipmentLineItem.code = item.code;
    const alreadyInCSDoc = await this.api.findCombinedShipment(item.code);
    // console.log('already in cs doc', alreadyInCSDoc);
    if (alreadyInCSDoc) {
      this.toastrService.danger(`Item ${item.nameOverride || item.code} already added to ${alreadyInCSDoc.nameOverride || alreadyInCSDoc.code}`, 'Validation Error');
      return;      
    }
    this.compilation.shipmentLineItems.forEach(li => {
      if (li.document.code === item.code) {
        this.toastrService.danger(`Item ${item.nameOverride || item.code} already added`, 'Validation Error');
        return;
      }
    });
    if (!shipmentLineItem.document.transportRun) shipmentLineItem.document.transportRun = new TransportRun();
    if (!this.compilation.shipmentLineItems.map(m => m.code).includes(shipmentLineItem.code)) this.compilation.shipmentLineItems.push(shipmentLineItem);
    this.evalDateFields.emit();
    await Changelog.addAutolog(this.compilation, this.auth.user, this.api, [{
      quickText: 'Change Shipment Line Items',
      text: 'Added: ' + getDocumentNumber(shipmentLineItem.document),
    }]);
    await Changelog.addAutolog(shipmentLineItem.document, this.auth.user, this.api, [{
      quickText: 'Change Shipment Line Items',
      text: `Added to ${getDocumentNumber(this.compilation)} (in CS by ${this.auth.user.short})`,
    }]);
    // this.updateSpoStatus();
    this.api.saveCompilation(shipmentLineItem.document);
  }

  async removeItem(idx: number) {
    const item = this.compilation.shipmentLineItems.splice(idx, 1);
    const spo = await this.api.loadCompilation(mongoId(item[0].document))
    item[0].document.exwJapanDate = spo.exwJapanDate = null;
    item[0].document.arrivingVieDate = spo.arrivingVieDate = null;
    item[0].document.transportRun.transportStatus = spo.transportRun.transportStatus = TransportStatusData.get('planned').id;
    await Changelog.addAutolog(this.compilation, this.auth.user, this.api, [{
      quickText: 'Change Shipment Line Items',
      text: 'Removed: ' + getDocumentNumber(item[0].document),
    }]);
    await Changelog.addAutolog(item[0].document, this.auth.user, this.api, [{
      quickText: 'Change Shipment Line Items',
      text: `Removed from ${getDocumentNumber(this.compilation)} (in CS by ${this.auth.user.short})`,
    }]);
    // this.updateSpoStatus();
    this.api.saveCompilation(spo);
  }

  getCustomerName(doc: CompilationModel) {
    if (!doc || !this.data.businesses) return '';
    const customer =  this.data.businesses.find(b => mongoId(b) === mongoId(doc.customerReference));
    return (customer && customer.name) || doc.customerName || '';
  }

  onMoveLineItem(idx: number, up: boolean) {
    const cut = this.compilation.shipmentLineItems.splice(idx, 1);
    this.compilation.shipmentLineItems.splice(idx + (up ? -1 : 1), 0, cut[0]);
  }

  getSpoStatus(item: CompilationModel) {
    const status = item && item.transportRun && item.transportRun.spoStatus;
    return (status && SpoStatusData.get(status).name) || 'Unconfirmed';
  }

  // updateSpoStatus() {
  //   if (!this.compilation.transportRun) this.compilation.transportRun = new TransportRun();
  //   const unconfirmed = this.tree.docNode.doc.shipmentLineItems.find( f =>
  //     f.document.transportRun && f.document.transportRun.spoStatus !== SpoStatusData.get('confirmed').id
  //   )
  //   this.compilation.transportRun.spoStatus = SpoStatusData.get(unconfirmed ? 'nconfirmed' : 'confirmed').id;
  // }

  getDisplayUnit(id: number) {
    return UnitData.get(id).short;
  }

  getWeight(el: LineItemModel) {
    if (el && el.finishedProduct && el.finishedProduct.content && el.finishedProduct.content.energy
      && el.finishedProduct.content.energy.width && el.finishedProduct.content.energy.rollLength
      && el.finishedProduct.product && el.finishedProduct.product.weight) {

      return (el.finishedProduct.content.energy.width / 1000)
          * el.finishedProduct.content.energy.rollLength
          * (el.finishedProduct.product.weight / 1000)
          * el.quantity
    }
    return '';
  }

  setDocument(item: CompilationModel) {
    this.setCurrentDocument.emit(item.code);
  }

  getSubTotalNet(item: CompilationModel) {
    let total = 0;
    item.lineItems.forEach(li => {
      if (li.quantity > 0 && li.piecePrice > 0) total += li.quantity*li.piecePrice;
    })
    return total;
  }

  getTotalNet() {
    let total = 0;
    this.compilation.shipmentLineItems.forEach(sli =>
      sli?.document?.lineItems?.forEach(li => {
        if (li.quantity > 0 && li.piecePrice > 0) total += li.quantity*li.piecePrice;
        this.compilation.currency = sli.document.currency;
      })
    );
    return total;
  }

  getSubTotalWeight(item: CompilationModel) {
    let total = 0;
    item.lineItems?.forEach(li => {
      total += (+this.getWeight(li));
    })
    return total;
  }

  getTotalWeight() {
    let total = 0;
    this.compilation.shipmentLineItems.forEach(sli => {
      sli.document?.lineItems?.forEach(li => {
        total += (+this.getWeight(li));
      })
    });
    return total;
  }

  getTotalM2() {
    return this.compilation.shipmentLineItems?.reduce((a,c) => {
      const m2 = c.document?.lineItems?.reduce((ali, cli) => ali + (this.getSqm(cli) || 0), 0);
      return a + (m2 || 0);
    }, 0)
  }

  getSqm(li: LineItemModel) {
    // if (!li.finishedProduct?.content) console.log('------> getSqm', li.finishedProduct );
    const length = (li.finishedProduct?.content?.energy || {})['rollLength'];
    const width = (li.finishedProduct?.content?.energy || {})['width'];
    return (li.quantity * length * width / 1000) || '';
  }

  // isDirectDelivery(li: LineItemModel) {
  //   const ocs = (li as any).relatedOcs;
  //   return ocs && ocs[0] && ocs[0].directDelivery;
  // }

  async setSposCompleted() {
    for (const sli of this.compilation.shipmentLineItems) {
      const spo = await this.api.loadCompilation(mongoId(sli.document));
      sli.document.transportRun.spoStatus = spo.transportRun.spoStatus = SpoStatusData.get('completed').id;
      sli.document.transportRun.transportStatus = spo.transportRun.transportStatus = TransportStatusData.get('completed').id;
      await this.api.saveCompilation(spo);
    }
    this.reloadItems.emit();
  }

  async uploadTestCertificate(item: ShipmentLineItem) {

    const doc = await this.api.loadCompilationByCode(item.code);
    this.dialogService.open(CommonDialogComponent, {
      context: {
        dialogType: NrkDialogType.upload,
        compilation: this.compilation,
        message: 'Add Test Certificate',
        files: doc.testCertificates
      },
    }).onClose.subscribe(x => {
      if (x?.response.files.length) {
        doc.testCertificates = item.document.testCertificates = x.response.files;
        this.api.saveCompilation(doc);
      }
    });
  }

  copyTCOverviewToClipboard() {
    let html = `
    <div>
    <div><b>TC overview</b></div>
    <div>&nbsp;</div>
    <table cellspacing="0" style="border-collapse:collapse;">
      <tr>
        <th style="background-color: lightgray;border:1px solid black;padding:5px;">PFSPO #</th>
        <th style="background-color: lightgray;border:1px solid black;padding:5px;">OBIC #</th>
        <!-- <th style="background-color: lightgray;border:1px solid black;padding:5px;">OBIC X/Y</th> -->
        <th style="background-color: lightgray;border:1px solid black;padding:5px;">Customer</th>
        <th style="background-color: lightgray;border:1px solid black;padding:5px;">Product</th>
        <th style="background-color: lightgray;border:1px solid black;padding:5px;"># of pieces</th>
        <th style="background-color: lightgray;border:1px solid black;padding:5px;">TC #</th>
        <th style="background-color: lightgray;border:1px solid black;padding:5px;">TC Y/N</th>
      </tr>`

      this.compilation.shipmentLineItems.forEach((doc, idx) => {
        html += `
          <tr>
            <td style="border:1px solid black;text-align:left;padding:5px;">${doc.code}</td>
            <td style="border:1px solid black;text-align:left;padding:5px;">${doc.document.lineItems?.reduce((a, c) => a + (c?.tbCode ? '\n' + c.tbCode : ''), '')}</td>
            <!-- <td style="border:1px solid black;text-align:center;padding:5px;">${doc.document.lineItems?.length}</td> -->
            <td style="border:1px solid black;text-align:left;padding:5px;">${this.getCustomerName(doc.document)}</td>
            <td style="border:1px solid black;text-align:left;padding:5px;">${doc.document.lineItems?.reduce((a, c) => a + (c?.productName ? '\n' + c.productName : ''), '')}</td>
            <td style="border:1px solid black;text-align:right;padding:5px;">${doc.document.lineItems?.reduce((a, c) => a + c.quantity, 0)}</td>
            <td style="border:1px solid black;text-align:left;padding:5px;">${doc.document.testCertificates?.reduce((a, c) => a + (c?.name ? '\n' + c.name : ''), '')}</td>
            <td style="border:1px solid black;text-align:center;padding:5px;">${doc.document.testCertificates?.length ? 'Y' : 'N'}</td>
          </tr>`
      });
    
    html += `</table></div>`

    this.data.copyHtmlToClipboard(html);
  }

  async saveAllPFSPOs() {

    const cs = this.compilation.code;
    this.parent.showDocumentPreview = true;
    this.cdRef.detectChanges();

    for (const spo of this.compilation.shipmentLineItems) {
      await this.parent.downloadPdf(spo.document);
    }
    this.parent.setCurrentDocumentByCode(cs);

  }

  sortLineItems(sortBy: number) {
    this.compilation.shipmentLineItems = [...this.compilation.shipmentLineItems].sort((a, b) => {
      if (sortBy === 3) {
        const dateA = a.document.customerRequestedDeliveryDate;
        const dateB = b.document.customerRequestedDeliveryDate;

        // Empty dates last
        const emptyDateA = isEmpty(dateA, true);
        const emptyDateB = isEmpty(dateB, true);

        if (emptyDateA !== emptyDateB) {
          return emptyDateA ? 1 : -1;
        }

        // Both dates are empty → sort by customer name
        if (emptyDateA && emptyDateB) {
          return (a.document.customerReference?.name ?? '')
            .localeCompare(b.document.customerReference?.name ?? '');
        }

        const diff = moment(dateA).diff(moment(dateB));

        if (diff !== 0) {
          return diff;
        }
      }
      
      if ([1, 3].includes(sortBy)){
        // Customer name ascending, empty names last
        const nameA = a.document.customerName;
        const nameB = b.document.customerName;

        // console.log('log sort by name', nameA, nameB, a, b);

        const emptyNameA = isEmpty(nameA, true);
        const emptyNameB = isEmpty(nameB, true);

        if (emptyNameA !== emptyNameB) {
          return emptyNameA ? 1 : -1;
        }

        return (nameA ?? '').localeCompare(nameB ?? '');
      }

      return ((a.document.nameOverride || a.code).localeCompare(b.document.nameOverride || b.code))

    });
  }

  moveToGsnr = ''
  async moveSpoToAnotherShipment(idx: number) {
    if (this.moveToGsnr) {
      const gsCode = this.data.compilationItems.find(f => f.nameOverride === this.moveToGsnr)?.code;
      if (gsCode) {
        const gs = await this.api.loadCompilationByCode(gsCode);
        const item = this.compilation.shipmentLineItems.splice(idx, 1);
        if (!gs.shipmentLineItems.map(m => m.code).includes(item[0].code)) gs.shipmentLineItems.push({
          document: item[0].document,
          code: item[0].code,
        });
        this.api.saveCompilation(gs);
      }
    }
  }

}
